import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OirHttpService } from '../../services/http/oir-http.service';
import { VideoSuggestion } from './video-suggestions.model';

@Injectable({ providedIn: 'root' })
export class VideoSuggestionsService {
  constructor(private oirHttp: OirHttpService) {}

  getVideos(route: string, moduleName: string): Observable<VideoSuggestion[]> {
    return this.oirHttp.get<VideoSuggestion[]>({
      requestUrl: 'CommsEndpoint',
      path: `/api/VideoSuggestions?route=${route}&moduleName=${moduleName}`
    });
  }
}
